export default "__VITE_ASSET__XEIvxFO7__"